const CONSUMPTION_RANGE = Array.from({ length: 21 }, (_, i) => i);

export { CONSUMPTION_RANGE };
